module.exports = __webpack_public_path__ + "img/wcbzj.5fc230b7.jpg";